<script>
import { required } from 'vuelidate/lib/validators'

import AssetEntry from './asset_entry'


export default {
	components: { AssetEntry },

	props: {
		assetsData: {
			type: Array,
			required: true
		}
	},
	methods: {

	}
}
</script>

<template>
	<b-card no-body class="mb-0 shadow-none">
		<b-card-body>
			<div v-for="asset in assetsData" class="row justify-content-sm-between mt-0 border-bottom pt-2 pb-2">
				<AssetEntry :asset="asset" />
			</div>
		</b-card-body>
	</b-card>
</template>


<style>
	.incident-status {
		width: 15%;
	}
	.incident-description {
		width: 35%;
	}
</style>